exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.operation[data-v-27d50ac6]{\r\n  height: 60px;\r\n  line-height: 60px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  border-bottom: 1px solid #DCDCDC;\n}\n.btn-container[data-v-27d50ac6]{\r\n  float: right;\n}\n.pagination[data-v-27d50ac6]{\r\n  text-align: right;\r\n  margin-top: 20px;\n}\r\n", ""]);

// exports
